<template>
    <div class="container-div">
        <div class="container-div" >

            <div class="clickable icon-container" :class="{'shake animated': newTasksReceived}" @click="openClose" v-click-outside="close">
                <x-icon class="notification-icon">notifications</x-icon>
            </div>

        </div>
        <x-flex v-show="isOpen" class="my-tasks-list-container">
            <div class="tasks-title">Notifications</div>
            <div/>
        </x-flex>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    name: "notificationIcon",
    directives: {
        ClickOutside
    },
    data() {
        return {
            isOpen: false,
            newTasksReceived: false
        };
    },
    computed: {
    },
    methods: {
        openClose() {
            this.isOpen = !this.isOpen;
        },
        close() {
            this.isOpen = false;
        },
    }
}
</script>

<style lang="scss" scoped>
    .container-div{
        position: relative;
    }
    .icon-container{
        display: inline-block;
    }
    .clickable{
        cursor: pointer;
    }
    .notification-icon{
        color: $color-white;
        font-size: 1.5em;
    }
    .indicator-circle{
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -13px;
        top: -13px;
        border-radius: 50%;
        background-color: $color-blue;
        color: $color-white;
        min-width: 30px;
        min-height: 30px;
    }
    .tasks-title{
        font-weight: 600;
        margin-bottom: 2em;
    }
    .my-tasks-list-container{
        position:absolute;
        background-color: $color-white;
        text-align: left;
        padding: 20px;
        width: 100%;
        max-height: 23em;
        overflow: auto;
    }
    .no-select {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .color-overdue{
        color: $color-overdue;
    }

    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .shake {
        -webkit-animation-name: shake;
        animation-name: shake;
    }
</style>
